module.exports = __webpack_public_path__ + "img/home.023e5a46.svg";